// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2Vmau","alert":"SettungsInbox_alert__105Bk"};